import { useEffect } from 'react'

const EMAIL = 'hello@mybst.ru'
const SITE = 'mybst.ru'

export function CookiesPage() {
  useEffect(() => {
    document.documentElement.classList.remove('dark')
    document.body.style.overflow = 'auto'
    document.body.style.height = 'auto'
    document.title = 'Политика Cookie — BST'
    return () => {
      document.body.style.overflow = ''
      document.body.style.height = ''
    }
  }, [])

  const section = (title: string, children: React.ReactNode) => (
    <section style={{ marginBottom: '32px' }}>
      <h2 style={{ fontSize: '16px', fontWeight: 700, color: '#1a1a1a', margin: '0 0 12px', borderBottom: '1px solid #e0e0e0', paddingBottom: '8px' }}>
        {title}
      </h2>
      <div style={{ fontSize: '14px', color: '#444', lineHeight: 1.8 }}>
        {children}
      </div>
    </section>
  )

  const cookieRow = (name: string, type: string, purpose: string, ttl: string) => (
    <tr key={name}>
      <td style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0', fontFamily: 'monospace', fontSize: '12px', color: '#5b6af0' }}>{name}</td>
      <td style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}>{type}</td>
      <td style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0', fontSize: '13px' }}>{purpose}</td>
      <td style={{ padding: '8px 12px', borderBottom: '1px solid #f0f0f0', fontSize: '13px', whiteSpace: 'nowrap' }}>{ttl}</td>
    </tr>
  )

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      fontFamily: "'Inter', 'Segoe UI', system-ui, sans-serif",
    }}>
      {/* Header */}
      <header style={{
        background: '#fff',
        borderBottom: '1px solid #e0e0e0',
        padding: '16px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
      }}>
        <a href="/" style={{ display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}>
          <div style={{
            width: '32px', height: '32px', borderRadius: '8px',
            background: '#5b6af0',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 900, color: '#fff', fontSize: '14px',
          }}>B</div>
          <span style={{ fontWeight: 900, fontSize: '20px', color: '#1a1a1a', letterSpacing: '-0.5px' }}>BST</span>
        </a>
        <span style={{ color: '#9b9b9b', fontSize: '13px', marginLeft: '4px' }}>/ Политика Cookie</span>
      </header>

      <main style={{ maxWidth: '780px', margin: '0 auto', padding: '40px 24px 60px' }}>
        <h1 style={{ fontSize: '26px', fontWeight: 900, color: '#1a1a1a', margin: '0 0 6px', letterSpacing: '-0.5px' }}>
          Политика использования файлов Cookie
        </h1>
        <p style={{ fontSize: '13px', color: '#9b9b9b', margin: '0 0 36px' }}>
          Редакция от 25 августа 2026 г.
        </p>

        {section('1. Что такое cookie?', <>
          <p>Cookie — это небольшие текстовые файлы, которые веб-сайт сохраняет в вашем браузере при посещении. Они позволяют сайту «запомнить» вас при следующем визите и улучшить пользовательский опыт.</p>
          <p>Помимо классических cookie, мы используем аналогичные технологии хранения: <strong>localStorage</strong> и <strong>sessionStorage</strong> браузера.</p>
        </>)}

        {section('2. Какие cookie мы используем', <>
          <div style={{ overflowX: 'auto', marginBottom: '16px' }}>
            <table style={{
              width: '100%', borderCollapse: 'collapse',
              background: '#fff', borderRadius: '10px', overflow: 'hidden',
              boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
            }}>
              <thead>
                <tr style={{ background: '#f5f5f5' }}>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: 700, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Название</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: 700, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Тип</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: 700, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Назначение</th>
                  <th style={{ padding: '10px 12px', textAlign: 'left', fontSize: '12px', fontWeight: 700, color: '#6b6b6b', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Срок</th>
                </tr>
              </thead>
              <tbody>
                {cookieRow('bst-token', 'Необходимый', 'JWT-токен авторизации', 'Сессия')}
                {cookieRow('bst-refresh', 'Необходимый', 'Токен обновления сессии', '30 дней')}
                {cookieRow('bst-auth', 'Необходимый', 'Флаг авторизованного состояния', '30 дней')}
              </tbody>
            </table>
          </div>
          <p>Указанные файлы (localStorage-записи) являются <strong>необходимыми</strong> — без них авторизация в Сервисе невозможна. Они не используются для отслеживания поведения пользователей и не передаются третьим лицам.</p>
        </>)}

        {section('3. Сторонние cookie', <>
          <p>В настоящее время Сервис <strong>не использует</strong> сторонние аналитические, рекламные или маркетинговые cookie (Google Analytics, Яндекс.Метрика и т.п.).</p>
          <p>При подключении Пользователем собственных скриптов к создаваемым сайтам (например, виджеты, чат-боты) ответственность за используемые ими cookie несёт Пользователь.</p>
        </>)}

        {section('4. Управление cookie', <>
          <p>Вы можете управлять cookie через настройки браузера:</p>
          <ul style={{ paddingLeft: '20px', margin: '4px 0 12px' }}>
            <li><strong>Chrome:</strong> Настройки → Конфиденциальность и безопасность → Файлы cookie</li>
            <li><strong>Firefox:</strong> Настройки → Приватность и защита → Cookie и данные сайтов</li>
            <li><strong>Safari:</strong> Настройки → Конфиденциальность → Управление данными веб-сайтов</li>
          </ul>
          <p style={{ padding: '12px 14px', background: 'rgba(245,158,11,0.08)', border: '1px solid rgba(245,158,11,0.2)', borderRadius: '8px', margin: '12px 0 0' }}>
            Обратите внимание: отключение или удаление необходимых cookie приведёт к выходу из аккаунта и невозможности авторизации в Сервисе.
          </p>
        </>)}

        {section('5. Изменение политики', <>
          <p>Мы можем обновлять настоящую Политику. Актуальная редакция всегда доступна по адресу <strong>{SITE}/cookies</strong>.</p>
        </>)}

        {section('6. Контакты', <>
          <p>По вопросам использования cookie пишите: <a href={`mailto:${EMAIL}`} style={{ color: '#5b6af0' }}>{EMAIL}</a></p>
        </>)}
      </main>

      <footer style={{
        background: '#fff', borderTop: '1px solid #e0e0e0',
        padding: '20px 24px', textAlign: 'center',
        fontSize: '13px', color: '#9b9b9b',
        display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap',
      }}>
        <a href="/terms" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Оферта</a>
        <a href="/privacy" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Конфиденциальность</a>
        <a href="/cookies" style={{ color: '#9b9b9b', textDecoration: 'none' }}>Cookie</a>
        <span>© {new Date().getFullYear()} BST</span>
      </footer>
    </div>
  )
}
